import React from 'react';
import {Grid} from '@material-ui/core';
import {WidgetCard} from 'components';
import {DeliveryInfoBox} from 'components/payment/BillingInfoBox';
import {DeliveryFormDialog} from 'components/forms/deliveryInfo';

const DisplayAndUpdateDeliveryAddress = ({highlight}) => {
    return (
        <WidgetCard
            clearCard
            title='Delivery Address on File'
            alignTitle='left'
            lg={6}
            highlight={highlight}
        >
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <DeliveryInfoBox />
                </Grid>
                <Grid item xs={12}>
                    <DeliveryFormDialog
                        variant='outlined'
                        color='primary'
                        buttonText='Edit Delivery Address'
                    />
                </Grid>
            </Grid>
        </WidgetCard>
    );
};

export default DisplayAndUpdateDeliveryAddress;
